import React, { Suspense } from 'react'
import { useInView } from 'react-intersection-observer'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import TopSection from './TopSection'
import BottomSection from './BottomSection'
import DestinationsCarousels from 'components/Common/DestinationsCarousel/DestinationCarousels'
import TopDestinationList from 'components/Common/TopDestinationsList/TopDestinationList'
import { Route } from 'react-router-dom'
import { rem } from 'polished'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import config from 'constants/config'
import BusinessTravellerFooter from './businesstraveller/BusinessTravellerFooter'

const Wrapper = styled.footer`
  ${mediaQueryUp.sm} {
    text-align: left;
  }
`

const TopSectionWrapper = styled.div`
  background-color: ${props => props.theme.palette.neutral.eight};
  border-top: 1px solid ${({ theme }) => theme.palette.neutral.five};
  padding-block: ${rem(32)};
  text-align: center;

  > * + * {
    margin-top: ${rem(16)};
  }


  ${mediaQueryUp.sm} {
    text-align: left;

    > * + * {
      margin-top: ${rem(32)};
    }
  }
`

function Footer() {
  const [footerRef, footerInView] = useInView({
    triggerOnce: true, // Load it once and keep it loaded
    rootMargin: '500px', // Trigger 500px before the component is reached
  })

  const showBusinessTravellerFooter = config.businessTraveller.currentAccountMode === 'business'

  return (
    <Suspense fallback={<LoadingIndicator />}>
      <Wrapper className="PageFooter" ref={footerRef}>
        {showBusinessTravellerFooter && <BusinessTravellerFooter />}
        {!showBusinessTravellerFooter && (
          <>
            <TopSectionWrapper>
              {footerInView && <Route exact path="/:regionCode" component={DestinationsCarousels} />}
              <Route exact path="/:regionCode(|hotels|home-preview)" component={TopDestinationList} />
              {footerInView && <TopSection />}
            </TopSectionWrapper>
            {footerInView && <BottomSection />}
          </>
        )}
      </Wrapper>
    </Suspense>
  )
}

export default Footer
